
export default {
    values: {
        'Operations gantt': 'Gantt de Operações',
        'Shows a gantt chart displaying the operations': 'Exibe um gráfico de Gantt com as operações',
        'Filters and settings are displayed in visualization mode only.':
            'Filtros e configurações são exibidos apenas em modo de visualização.',
        'Save this widget and return to the dashboard.': 'Salve esse widget e retorne ao dashboard.'
    }
}
